import { useState } from 'react'
import { useAppStore } from 'lib/hooks/useAppStore'
import { useForm } from 'react-hook-form'
import { AnimatePresence, motion } from 'motion/react'
import { Input } from 'components/Account/Input'
import { Button } from 'components/Global/Button'

export const NotifyOverlay = () => {
  const { notifyId, setNotifyId } = useAppStore()
  const { register, reset, handleSubmit } = useForm()
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState(false)

  const onSubmit = async (data) => {
    setError(null)

    try {
      const response = await fetch('/api/klaviyo/notify', {
        method: 'POST',
        body: JSON.stringify({
          email: data.email,
          id: notifyId,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (response.status !== 200) {
        setError('Something went wrong, please try again')
        return
      }
      setSuccess(true)
      reset({
        email: '',
      })
      setTimeout(() => {
        setSuccess(false)
        setNotifyId(null)
      }, 5000)
    } catch (error) {
      setError(error.message)
    }
  }

  return (
    <AnimatePresence>
      {notifyId !== null ? (
        <motion.div className="fixed z-[50] flex h-screen w-full items-center justify-center px-20 text-12 leading-120 text-darkerGray">
          <motion.button
            className="absolute inset-0 z-0 cursor-pointer bg-blackTransparent backdrop-blur-[20px] will-change-auto"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            layout
            transition={{
              duration: 0.3,
              ease: 'easeIn',
            }}
            onClick={() => setNotifyId(null)}
          />
          <motion.form
            onSubmit={handleSubmit(onSubmit)}
            className="relative z-[1] w-[calc(100%-40px)] overflow-hidden rounded-8 bg-white p-10 text-center md:w-auto md:min-w-[400px]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 0.3,
              ease: 'easeIn',
            }}
          >
            <AnimatePresence>
              {success ? (
                <motion.div
                  className="absolute inset-0 z-[4] flex h-full w-full flex-col items-center justify-center gap-10 bg-white px-40"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <span>
                    Thanks! You’ll be the first to know when this product is
                    back in stock ◡̈
                  </span>
                  <button
                    className="underline"
                    onClick={() => setNotifyId(null)}
                  >
                    Close
                  </button>
                </motion.div>
              ) : null}
            </AnimatePresence>
            <p className="pb-20 pt-10">
              We will let you know when this is back in stock
            </p>
            <div className="flex flex-col gap-10">
              <Input
                className="!py-14 text-center"
                type="email"
                id="email"
                label="Email Address"
                register={register}
              />
              <Button className="bg-yellow py-14 text-center uppercase">
                Notify me
              </Button>
            </div>
            {error ? <p className="pt-10">{error}</p> : null}
          </motion.form>
        </motion.div>
      ) : null}
    </AnimatePresence>
  )
}
